module.exports = __webpack_public_path__ + "img/logo-footer.62d4bebc.png";